var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c(
        "a-page-header",
        { staticClass: "page-header", on: { back: _vm.back } },
        [
          _c(
            "div",
            {
              staticStyle: { cursor: "pointer" },
              attrs: { slot: "title" },
              on: { click: _vm.back },
              slot: "title",
            },
            [
              _vm._v("\n      返回\n      "),
              _c("span", { staticClass: "header-title" }, [
                _vm._v(_vm._s(_vm.stuInitInfo.pageName || "")),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        [
          _c("PersonalDetails", {
            attrs: {
              basicInfoProp: _vm.basicInfo,
              loading: _vm.loading,
              beginDate: _vm.beginDate,
              endDate: _vm.endDate,
            },
            on: { search: (data) => _vm.refreshArchives(data, 1) },
          }),
          _c("MoodArchives", {
            ref: "moodArchives",
            attrs: { stuInitInfo: _vm.stuInitInfo },
          }),
          _c("StuCareArchivesRecord", {
            attrs: {
              timeline: _vm.timeline,
              loading: _vm.careLoading,
              stuInitInfo: _vm.stuInitInfo,
              beginDate: _vm.beginDate,
              endDate: _vm.endDate,
            },
            on: { refreshData: (data) => _vm.refreshArchives(data, 2) },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }